import { Container, Divider } from "@material-ui/core";
import { Box, Grid } from "@mui/material";
import axios from "axios";
import {
  ArrayTagChip,
  AutoCompleteComponent,
  CurrencyDisplay,
  CustomTable,
  ModalError,
  Page,
  PrimaryButton,
  SearchTextInput,
  SectionLabel,
  SelectInput,
  SkeletonComponent,
  SongUsageTrendChart,
  SongUsageTrendSummarytCard,
  YearPicker,
} from "components";
import { month } from "constants";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { downloadFileFromRes, getErrors } from "utils";

const PenciptaReviewLagu = () => {
  const classes = globalStyles();
  const history = useHistory();
  const isFirstLoad = useRef(true);
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const urlParams = new URLSearchParams(location.search);
  const paramsSearch = urlParams.get("search");
  const paramsPage = urlParams.get("page");
  const paramsSize = urlParams.get("size");
  const paramsDsp = urlParams.get("dsp_ids");
  const paramsYear = urlParams.get("year");
  const paramsMonth = urlParams.get("months");

  const [loadingPage, setLoadingPage] = useState(false);
  const [optionDsp, setOptionDsp] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    dsp_ids: Number(paramsDsp) || localStorage.getItem("idDsp") || "",
    year: Number(paramsYear) || moment().year(),
    months: Number(paramsMonth) || 0,
  });
  const [tableParams, setTableParams] = useState({
    page: Number(paramsPage) || 1,
    size: Number(paramsSize) || 10,
    search: paramsSearch || "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [chartReport, setChartReport] = useState({
    revenue: 0,
    traffic: 0,
    month: "",
    totalRevenue: 0,
    totalTraffic: 0,
  });
  let selectedDSP = optionDsp?.find(
    dsp => dsp?.dsp_id === Number(queryParams?.dsp_ids)
  );

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      [key]: value,
    }));
    handleChangePageParams(value, key);
  };
  const handleChangeTableParams = (value, key) => {
    setTableParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
    handleChangePageParams(value, key);
    if (key !== "page") {
      handleChangePageParams(1, "page");
    }
  };
  const handleChangePageParams = (value, key) => {
    urlParams.set(key, value);
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };
  const handleChangeChartReport = (value, key) => {
    setChartReport(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const onClickChartAxis = data => {
    if (chartData?.datasets.length > 0) {
      const { dataIndex, axisValue } = data;
      let monthTotalTraffic = 0;
      let monthTotalRevenue = 0;

      chartData?.datasets?.forEach(dataset => {
        monthTotalTraffic += dataset?.listener?.[dataIndex] || 0;
        monthTotalRevenue += dataset?.data?.[dataIndex] || 0;
      });

      const monthName = moment(axisValue, "MMM YY").format("MMMM");

      handleChangeChartReport(monthTotalTraffic, "traffic");
      handleChangeChartReport(monthTotalRevenue, "revenue");
      handleChangeChartReport(monthName, "month");
    }
  };

  const getDefaultDSP = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/dashboard/options/valuated_dsp`,
        { headers }
      );
      handleChangeQueryParams(res?.data?.data?.[0]?.dsp_id, "dsp_ids");
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getOptionDsp = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/dashboard/options/dsp`, {
        headers,
      });
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        id: item?.dsp_id,
        label: item?.name,
      }));
      setOptionDsp(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/composer/song-usage/v2/table`,
        {
          headers,
          params: { ...queryParams, ...tableParams },
        }
      );
      const { data, meta } = res?.data;
      setDataTable(data?.data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setLoadingPage(false);
    }
  };

  const getChartData = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/composer/dashboard/v2/chart`,
        {
          headers,
          params: {
            ...queryParams,
            search: tableParams?.search || "",
          },
        }
      );
      const { data } = res?.data || [];
      if (data) {
        const labels = data?.charts?.[0]?.items?.map(item =>
          moment(item.date).format("MMM YY")
        );
        const datasets = data?.charts.map(item => ({
          label: item?.dsp_name,
          data: item?.items?.map(chartItem => chartItem?.revenue),
          listener: item?.items?.map(chartItem => chartItem?.total_stream),
          color: item?.color,
          showMark: false,
        }));
        setChartData({
          labels,
          datasets,
        });
        setChartReport(currentState => ({
          ...currentState,
          totalRevenue: data?.total_revenue,
          totalTraffic: data?.total_stream,
        }));
      } else {
        setChartData({
          labels: [],
          datasets: [],
        });
        setChartReport({
          revenue: 0,
          traffic: 0,
          month: "",
          totalRevenue: 0,
          totalTraffic: 0,
        });
      }
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    }
  };

  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams, tableParams]
  );

  const debounceDataChart = useCallback(
    debounce(() => {
      getChartData();
    }, 500),
    [queryParams, tableParams]
  );

  const handleDownloadExcel = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/composer/song-usage/v2/table/export`,
        {
          headers,
          params: {
            ...queryParams,
            ...tableParams,
            page: -1,
            original_publisher_id: localStorage.getItem("mainDsp") || 0,
          },
          responseType: "blob",
        }
      );
      downloadFileFromRes(res);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };

  const fetchData = async () => {
    setLoadingPage(true);
    const promises = [];
    promises.push(getDefaultDSP());
    promises.push(getOptionDsp());
    promises.push(getDataTable());
    promises.push(getChartData());

    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
      isFirstLoad.current = false;
    }
  };

  useEffect(() => {
    if (!isFirstLoad.current) {
      const isSearching = Boolean(tableParams?.search);
      if (isSearching) {
        debounceDataTable();
        debounceDataChart();
        return () => {
          debounceDataTable.cancel();
          debounceDataChart.cancel();
        };
      } else {
        getDataTable();
        debounceDataChart();
      }
    } else {
      fetchData();
    }
  }, [queryParams, tableParams]);

  return (
    <Page className={classes.root} title="Song Usage Review">
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle title="Song Usage" breadcrumbData={breadcrumbData} />
          <Divider className={classes.divider} />
          <Box
            border="1px solid #ebebeb"
            borderRadius="5px"
            p="24px"
            mt="16px"
            bgcolor="#F9FAFB"
          >
            <Grid container spacing={1}>
              <Grid item>
                <AutoCompleteComponent
                  label="DSP"
                  options={optionDsp}
                  value={
                    optionDsp.find(
                      option => option.id === queryParams?.dsp_ids
                    ) || null
                  }
                  onChange={value => handleChangeQueryParams(value, "dsp_ids")}
                  size="small"
                  width={250}
                />
              </Grid>
              <Grid item>
                <SelectInput
                  label="Outside DSP"
                  value={""}
                  options={[{ id: "", label: "None" }]}
                  optionKey="id"
                  optionLabel="label"
                  width={250}
                />
              </Grid>
              <Grid item>
                <SelectInput
                  label="Month"
                  value={queryParams?.months || ""}
                  onChange={e =>
                    handleChangeQueryParams(e?.target?.value, "months")
                  }
                  options={month?.slice(1)}
                  optionKey="id"
                  optionLabel="name"
                  placeholder="All Month"
                  width={250}
                />
              </Grid>
              <Grid item>
                <YearPicker
                  label="Year"
                  value={queryParams?.year}
                  onChange={date => handleChangeQueryParams(date, "year")}
                  width={250}
                />
              </Grid>
            </Grid>
          </Box>
          <SectionLabel title="Trend of Song Usage" my="16px" />
          <Box
            border="1px solid #ebebeb"
            borderRadius="5px"
            padding="50px 20px"
            my={3}
          >
            <Box mb={2}>
              {chartData?.datasets.length > 0 && queryParams?.dsp_ids && (
                <ArrayTagChip selectionsList={[selectedDSP]} value="name" />
              )}
            </Box>
            <SongUsageTrendChart
              chartData={chartData}
              onAxisClick={(_, data) => onClickChartAxis(data)}
            />
          </Box>
          <SongUsageTrendSummarytCard chartReport={chartReport} />
          <Grid container justifyContent="space-between" my="16px">
            <Grid item>
              <SearchTextInput
                placeholder="Song title, Composer"
                onChange={e =>
                  handleChangeTableParams(e?.target?.value, "search")
                }
                value={tableParams?.search}
              />
            </Grid>
            <Grid item>
              <Grid container columnSpacing={1}>
                <Grid item>
                  <PrimaryButton
                    label="Download PDF"
                    onClick={() =>
                      history.push({
                        pathname: "/admin/review-lagu/print-report",
                        state: {
                          dataTable,
                          chartData,
                          chartReport,
                          selectedDSP,
                        },
                      })
                    }
                    size="large"
                  />
                </Grid>
                <Grid item>
                  <PrimaryButton
                    label="Download XLSX"
                    size="large"
                    onClick={handleDownloadExcel}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <CustomTable
            columnTable={columnTable}
            data={dataTable}
            page={tableParams?.page}
            pageSize={tableParams?.size}
            pageCount={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeTableParams(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeTableParams(e?.target?.value, "size")
            }
            isHaveAction
            renderAction={item => (
              <PrimaryButton
                label="See Details"
                onClick={() =>
                  history.push({
                    pathname: `/pencipta/review-lagu/${item.song_id}`,
                    state: {
                      song: item,
                      queryParams,
                    },
                  })
                }
                width={140}
              />
            )}
          />
        </Container>
      )}
    </Page>
  );
};

const breadcrumbData = [
  {
    label: "Home",
    link: "/pencipta/dashboard-pencipta",
  },
  {
    label: "Song Usage",
    active: true,
  },
];
const columnTable = [
  {
    name: "song_title",
    title: "Song title",
    renderText: item => item || "-",
  },
  {
    name: "iswc",
    title: "ISWC",
    renderText: item => item || "-",
  },
  {
    name: "stream",
    headerAlign: "right",
    title: "Traffic",
    renderText: item => <CurrencyDisplay value={item} />,
  },
  {
    name: "revenue",
    headerAlign: "right",
    title: "Revenue",
    renderText: item => (
      <CurrencyDisplay value={item} prefix="Rp " decimalScale={2} />
    ),
  },
];

export default PenciptaReviewLagu;
